/* eslint-disable  react/no-deprecated */
/* eslint-disable  react/no-access-state-in-setstate */

import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import EquipmentForm from 'components/modules/equipment/EquipmentForm';
import EquipmentStore from 'stores/EquipmentStore';
import SessionStore from 'stores/SessionStore';
import EquipmentActionCreators from 'actions/EquipmentActionCreators';
import { equipmentTypesMapping } from 'constants/Equipment';
import { checkEquipmentExists } from 'utils/EquipmentWebAPIUtils';
import { sluggify } from 'utils/localization/utils';
import Alert from 'components/ui/Alert';

class AddEquipmentModal extends React.Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    equipment: PropTypes.object.isRequired,
    onHide: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      equipment: {
        equipment_id: '',
        _equipmentType: 'container',
        _equipmentSize: null,
        _type: null,
        last_free_date: null,
        earliest_empty_date: null,
        earliest_return_date: null,
        last_cut_date: null,
        status: 'N/A',
        order: null,
        is_private: false,
        chassis_owner_type: null,
        chassis_owner: null,
      },
      error: {},
      success: '',
      isAdmin: SessionStore.isAdmin(),
      addNewEquipmentError: null,
    };
  }

  componentDidMount() {
    EquipmentStore.addEquipmentFormListener(this.handleStoreChange);
    if (this.props.equipment && this.props.equipment._id) {
      EquipmentActionCreators.getEquipmentAuditEvents(this.props.equipment._id);
    }
    SessionStore.addChangeListener(this.handleSessionStoreChange);
  }

  componentWillReceiveProps(props) {
    if (!this.props.show && props.show) {
      if (props.equipment && props.equipment._id) {
        EquipmentActionCreators.getEquipmentAuditEvents(props.equipment._id);
      }
      this.setState({
        equipment: props.equipment,
      });
    }
  }

  componentWillUnmount() {
    EquipmentStore.removeEquipmentFormListener(this.handleStoreChange);
    SessionStore.removeChangeListener(this.handleSessionStoreChange);
  }

  handleSessionStoreChange = () => {
    const isAdmin = SessionStore.isAdmin();
    this.setState({
      isAdmin,
    });
  };

  handleStoreChange = () => {
    const { t } = this.props;
    const formStatus = EquipmentStore.getFormStatus();
    if (formStatus.success) {
      this.setState({
        error: {},
        success: t('EQUIPMENT_SUCCESSFULLY_UPDATED'),
      });
      setTimeout(() => this.handleHide(), 1500);
    } else {
      const error = { ...this.state.error };
      Object.keys(formStatus.error).forEach((key) => {
        error[key] = formStatus.error[key];
      });

      this.setState({
        error,
      });
    }
  };

  handleHide = () => {
    this.setState({
      equipment: null,
      error: {},
      success: {},
    });
    this.props.onHide();
  };

  handleChange = (field, value) => {
    this.setState((currentState) => {
      const { equipment: currentEquipment } = currentState;

      const equipment = {
        ...currentEquipment,
        [field]: value,
      };

      /**
       * Reset chassis_owner_type and chassis_owner if is_private is set to false.
       */
      const fieldResetRequiredWhenToggleOff = field === 'is_private' && !value;
      if (fieldResetRequiredWhenToggleOff) {
        equipment.chassis_owner_type = null;
        equipment.chassis_owner = null;
      }

      /**
       * Below fields are not part of trailer and container,
       * so reset to default whenever _equipmentType changes
       */
      const fieldResetRequiredForNotChassisType =
        field === '_equipmentType' && value !== equipmentTypesMapping.CHASSIS;
      if (fieldResetRequiredForNotChassisType) {
        equipment.chassis_owner_type = null;
        equipment.chassis_owner = null;
        equipment.is_private = false;
      }
      /**
       * Below fields are not part of chassis and trailer,
       * so reset to default whenever _equipmentType changed to chassis or trailer
       */
      const fieldResetRequiredForNotContainer =
        field === '_equipmentType' && value !== equipmentTypesMapping.CONTAINER;
      if (fieldResetRequiredForNotContainer) {
        equipment._equipmentSize = null;
        equipment._type = null;
      }

      return {
        equipment,
      };
    });
  };

  handleSave = async () => {
    try {
      const { entity: equipmentData } = await checkEquipmentExists(
        this.state.equipment,
      );
      if (equipmentData.exists === true) {
        this.setState({ addNewEquipmentError: 'EQUIPMENT_ALREADY_EXIST' });
      }
      if (equipmentData.exists === false) {
        this.setState(
          { addNewEquipmentError: null, addEquipmentFormVisible: false },
          () => this.props.onSave(this.state.equipment),
        );
      }
    } catch (e) {
      if (sluggify(e.entity.message) === 'EQUIPMENT_MISMATCH') {
        this.setState({ addNewEquipmentError: 'MISMATCHED_EQUIPMENT_TYPE' });
      }
    }
  };

  componentToRender() {
    const { t } = this.props;
    const { addNewEquipmentError } = this.state;
    return (
      <div className="bg-grey-lightest p-4">
        {addNewEquipmentError && (
          <Alert className="mb-4" title={t('ERRORS')} type="error">
            <ul>
              <li key={1}>{t(addNewEquipmentError)}</li>
            </ul>
          </Alert>
        )}
        <EquipmentForm
          equipment={this.state.equipment}
          error={this.state.error}
          success={this.state.success}
          onFieldChange={this.handleChange}
          onSave={this.handleSave}
          onCancel={this.handleHide}
          isAdmin={this.state.isAdmin}
          isNew
        />
      </div>
    );
  }

  render() {
    const { t } = this.props;
    return (
      <Modal show={this.props.show} onHide={this.handleHide}>
        <Modal.Header style={{ border: 'none' }} closeButton>
          <Modal.Title>{t('ADD_EQUIPMENT')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{this.componentToRender()}</Modal.Body>
      </Modal>
    );
  }
}

export default withTranslation()(AddEquipmentModal);
